import axios from 'axios'
import { getSessionCachedData } from '@/utils/sessionDataCache'

const WITHDRAW_CONDITION_CACHE_TTL_MS = 30 * 1000

async function fetchWithdrawCondition (key) {
  const response = await axios.request({
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://asia-east2-fun-beyond.cloudfunctions.net/getWithdrawCondition',
    headers: {
      'x-api-key': 'LosnQ8W6uWoVs8N-ik_',
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({ key }),
    timeout: 8000
  })
  return response.data || null
}

export function getWithdrawConditionOnce (userKey) {
  const key = String(userKey || '').trim()
  if (!key) return Promise.resolve(null)

  return getSessionCachedData(`withdraw-condition:${key}`, () => fetchWithdrawCondition(key), WITHDRAW_CONDITION_CACHE_TTL_MS)
}

export async function getPendingWithdrawalStatus (userKey) {
  const key = String(userKey || '').trim()
  if (!key) throw new Error('userKey is required')
  const condition = await fetchWithdrawCondition(key)
  return Boolean(condition && condition.pendingWithdrawal === true)
}
